import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';

export const MapViewContainer = styled.div<StyledUiContainerProps>`
  gap: 1em;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;

  @media (max-width: 1350px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 950px) {
    display: flex;
    flex-direction: column;
    grid-gap: 1em;
  }
`;
